import { Table, Input } from "antd";
import dayjs from "dayjs";

const SuffixInvList = ({ salesOrderData, setSalesOrderData }) => {
  const dataSource = salesOrderData?.suffixInventories?.map((inv, index) => ({
    key: index,
    ...inv,
  }));

  const handlePurchaseRateChange = (value, record) => {
    // Remove non-numeric characters
    const numericValue = String(value).replace(/\D/g, "");

    // Update the inventory data
    const updatedInventories = salesOrderData.suffixInventories.map((inv) => {
      if (inv._id === record._id) {
        return {
          ...inv,
          purchaseRate: Number(numericValue),
        };
      }
      return inv;
    });

    // Update the salesOrderData state
    setSalesOrderData((prevData) => ({
      ...prevData,
      suffixInventories: updatedInventories,
    }));
  };

  const columns = [
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
      align: "center",
    },
    {
      title: "Suffix Code",
      dataIndex: "suffixCode",
      key: "suffixCode",
      align: "center",
    },
    {
      title: "Suffix Info",
      dataIndex: "suffixInfo",
      key: "suffixInfo",
      align: "center",
    },
    {
      title: "Purchase Rate",
      dataIndex: "purchaseRate",
      key: "purchaseRate",
      align: "center",
      width: 150,
      render: (value, record) => (
        <Input
          value={value || ""}
          onChange={(e) => handlePurchaseRateChange(e.target.value, record)}
        />
      ),
    },
    {
      title: "Billing Amount",
      dataIndex: "specialRate",
      key: "specialRate",
      align: "center",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      align: "center",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      align: "center",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Profit/Loss",
      key: "profitLoss",
      align: "center",
      render: (_, record) => {
        // Check if purchaseRate is zero or not a valid number
        if (!record.purchaseRate || record.purchaseRate === 0) {
          return "-";
        }

        const profitLoss =
          ((record.specialRate - record.purchaseRate) / record.purchaseRate) *
          100;
        return (
          <span style={{ color: profitLoss >= 0 ? "green" : "red" }}>
            {Math.abs(profitLoss).toFixed(2)}%
          </span>
        );
      },
    },
  ];

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
            textAlign: "center",
          }}
        />
      ),
    },
  };

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      components={components}
      scroll={{ x: "max-content" }}
    />
  );
};

export default SuffixInvList;
